import React, { useState, useEffect, Fragment } from 'react'
import { useSelector } from 'react-redux';
import AuthRequest from './AuthAccountPanels/AuthRequest'
import { List, ListSection, ListTabSection } from '../Common/List';
import { transDate } from '../libs/Util';
import Table from '../Common/Table';
import AuthRequestList from './AuthAccountPanels/AuthRequestList'

const UserInfoAcc = (props) => {
    const loginInfo = useSelector(state => state.login);
    const userId = loginInfo.userId ?? "";
    const [isShowRequestPopup, setIsShowRequestPopup] = useState(false);
    const [authKind, setAuthKind] = useState("");
    const [isMount, setIsMount] = useState(true);

    useEffect(() => {
        setIsMount(true);
        return () => {
            setIsMount(false);
        }
    }, []);

    useEffect(() => {
        setIsShowRequestPopup(authKind !== "");
    }, [authKind]);

    useEffect(() => {
        if (!isShowRequestPopup) setAuthKind("");
    }, [isShowRequestPopup]);

    const sections = [
        {
            type: "dev",
            title: "개발 권한"
        },
        {
            type: "acc",
            title: "개발 서버 접속 권한"
        }
    ];

    const devAuthOptions = {
        "1": "패키지AS",
        "2": "Ever",
        "3": "사업부AS",
        "4": "협력사AS",
        "5": "고객사AS"
    };

    const [accAuth, setAccAuth] = useState([]);
    const [devAuth, setDevAuth] = useState([]);

    useEffect(() => {
        getMyAccInfo();
    }, []);

    //내 권한 조회
    const getMyAccInfo = () => {
        let body = {
            userId: userId
        }
        fetch('api/User/GetMyAccInfo', {
            method: 'POST',
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then((data) => {
                setAccAuth(data.table);
                setDevAuth(data.table1);
            });
    };

    const viewAuthInfo = (info) => {
        // console.log(info);
    };

    const getAuthInfo = (datas, type) => {
        let result = []
        let isServer = type === "acc";

        if (datas.length > 0)
            for (let i = 0; i < datas.length; i++) {
                const groupKind = isServer ? null : datas[i].addDevGroupSeq === null || datas[i].addDevGroupSeq === 0 || datas[i].basicDevGroupName === datas[i].addDevGroupName ? "basic" : "add";
                const devGroupName = isServer ? datas[i].devGroupName : groupKind === "basic" ? devAuthOptions[datas[i].basicDevGroupSeq] : devAuthOptions[datas[i].addDevGroupName];
                const diffDate = isServer ? datas[i].diffDate : groupKind === "basic" ? datas[i].basicDiffDate : datas[i].addDiffDate;
                const fromDate = isServer ? datas[i].fromDate : datas[i].reqDate;
                const toDate = isServer ? datas[i].toDate : groupKind === "basic" ? datas[i].basicDevExpDate : datas[i].addDevExpDate;

                result.push(
                    <li key={devGroupName} className={`type-${type}`} onClick={() => viewAuthInfo(datas[i])}>
                        <div className="auth-name"><i></i><p className="txt">{devGroupName}</p></div>
                        <div className="d-count"><div className={diffDate > 7 ? "tag-count" : "tag-count expire"}>D-{diffDate > 999 ? "999+" : diffDate}</div></div>
                        <div className="period">{fromDate} ~ {toDate}</div>
                    </li>
                )
            }

        return result;
    };

    const buttons = [
        {
            type: "dev",
            title: "개발 권한",
            default: false,
            state: "U",
            column: [
                '개발권한',
                "권한적용일",
                "권한만료일",
                "상태"
            ]
        },
        {
            type: "acc",
            title: "접속 권한",
            default: true,
            state: "G",
            column: [
                '그룹권한',
                "권한적용일",
                "권한만료일",
                "상태"
            ]
        }
    ];

    const myinfooptions = [
        { value: "만료", class: "waiting color-t5" },
        { value: "적용중", class: "appr color-primary" },
        { value: "기본권한 적용중", class: "appr color-primary" }
    ];

    const companySeq = loginInfo.companySeq;

    const [columns, setColumns] = useState([]);
    const [btnState, setBtnState] = useState('U');
    const [myInfoData, setMyInfoData] = useState([]);
    const [list, setList] = useState([]);

    useEffect(() => {
        buttons.forEach((item) => {
            if (item.state === btnState)
                setColumns(item.column);
        })
        getMyAccInfoHistory(btnState);
    }, [btnState]);

    useEffect(() => {
        setList(registerList(myInfoData));
    }, [myInfoData]);

    //내 권한 변경이력 조회
    const getMyAccInfoHistory = (btnState) => {
        let body = {
            state: btnState,
            userId: userId,
            companySeq: companySeq
        }
        fetch('api/User/GetMyAccInfoHistory', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then((data) => {
                setMyInfoData(data.table);
            });
    };

    const registerList = (data) => {
        let list = [];
        if (data.length < 1) {
            return null;
        }
        for (let i = 0; i < data.length; i++) {
            if (data[i].addDevGroupName === '' && data[i].status === '만료') {
                data[i].addDevGroupName = data[i].basicDevGroupName;
                data[i].toDate = data[i].basictoDate;
            }

            const findIndex = myinfooptions.findIndex(element => element.value === data[i].status);
            if (findIndex != null && findIndex > 0) {
                let classtype = myinfooptions[findIndex].class ?? '';
                let innerstr = myinfooptions[findIndex].value;
                list.push(
                    <Fragment key={i}>
                        <tr>
                            <td>{(btnState === 'G' ? data[i].devGroupName :
                                (innerstr === '기본권한 적용중' ? data[i].basicDevGroupName : data[i].addDevGroupName))}
                            </td>
                            <td>{transDate(data[i].fromDate)}
                            </td>
                            <td>
                                {(innerstr === '기본권한 적용중' ? transDate(data[i].basictoDate) : transDate(data[i].toDate))}
                            </td>
                            <Fragment>
                                <td className={classtype}>
                                    {innerstr}
                                </td>
                            </Fragment>
                        </tr>
                    </Fragment>
                );
            }
        }
        return list;
    };
    const requestDevAuth = () => {
        setAuthKind('auth-dev');
    }
    const requestAccAuth = () => {
        setIsShowRequestPopup(true)
        setAuthKind('auth-acc');
    }
    return (
        <>
            <div className="myinfo-cnts">
                {isShowRequestPopup ? <AuthRequest setIsShowRequestPopup={setIsShowRequestPopup} authKind={authKind} /> : null}
                <h3 className='myinfo-cnts-title'>개발권한</h3>
                <div className="myinfo-cnts-wrap">
                    <div className="auth">
                        <div className='auth-wrap'>
                            <h3 className='auth-title'>내 권한</h3>
                            <div className='auth-cnts'>
                                <div className='auth-box'>
                                    <div className="auth-box-top">
                                        <p className='auth-box-title'>개발권한</p>
                                        {loginInfo.userRole.includes('Ylw') ? <button className='auth-box-button' onClick={requestDevAuth}>권한신청</button> : null}
                                    </div>
                                    <hr></hr>
                                    {devAuth.map((x, i) => {
                                        return (
                                            <div key={i} className='auth-box-btm'>
                                                <p className='auth-list-cate'>{devAuthOptions[x.basicDevGroupSeq]}</p>
                                                <p className='auth-list-date'>{x.reqDate} - {x.basicDevExpDate}</p>
                                            </div>
                                        );
                                    }
                                    )}

                                </div>
                                <div className='auth-box'>
                                    <div className="auth-box-top">
                                        <p className='auth-box-title'>개발서버 접속권한</p>
                                        {loginInfo.userRole.includes('Ylw') ? <button className='auth-box-button' onClick={requestAccAuth}>권한신청</button> : null}
                                    </div>
                                    <hr></hr>
                                    {accAuth.map((x, i) => {
                                        return (
                                            <div key={i} className='auth-box-btm'>
                                                <p className='auth-list-cate'>{x.devGroupName}</p>
                                                <p className='auth-list-date'>{x.fromDate} - {x.toDate}</p>
                                            </div>
                                        );
                                    }
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='auth-wrap'>
                            <h3 className='auth-title'>변경이력</h3>
                            <div className='auth-cnts'>
                                <div className="list-tab">
                                    {buttons.map((x, i) => {
                                        return (
                                            <div key={i} className="item">
                                                <input name={"history-tab"} type="radio" id={`auth-${x.type}`} checked={btnState === x.state} readOnly />
                                                <label htmlFor={`auth-${x.type}`} onClick={() => setBtnState(x.state)}>{x.title}</label>
                                            </div>
                                        )
                                    })}
                                </div>

                                <Table className={"auth-history"} headers={columns} list={list} />

                            </div>
                        </div>
                        {
                            loginInfo.userRole.includes('Ylw') ?
                                <div className='auth-wrap'>
                                    <h3 className='auth-title'>신청내역</h3>
                                    <AuthRequestList />
                                </div>
                                : null
                        }

                    </div>
                </div>
            </div>
        </>
    );
}
export default UserInfoAcc;